const insertIf = (condition, item) => (condition ? [item] : []);

export default insertIf;
